import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isNil } from 'lodash-es';

import { formatPercentage, numberWithDelimiter } from '../utils/formatters';

const STORES = {
  itunes_connect: { icon: 'hicon-apple', name: 'iOS App Store' },
  google_play: { icon: 'hicon-play', name: 'Google Play' },
};

const ProgressCells = ({ label, value, barClass }) => {
  const safeValue = isNil(value) ? 0 : value;

  return (
    <>
      <td>{label}</td>
      <td width="25%" aria-label={`${label} percentage`}>
        <div className="progress">
          <div className={cx('progress-bar', barClass)} style={{ width: `${safeValue * 100}%` }} />
        </div>
      </td>
      <td className="text-xxs-left">{formatPercentage(safeValue)}</td>
    </>
  );
};

ProgressCells.propTypes = {
  label: T.string.isRequired,
  value: T.number,
  barClass: T.string,
};

const StoreSummary = ({ store, summary }) => {
  const { icon, name } = STORES[store] || {};

  return (
    <div className="text-xxs-center">
      <div className="m-t" style={{ fontSize: 72, color: '#6a7387' }}>
        <i className={`${icon} store-icon m-b`} title={name} />
      </div>
      <h2 className="text-md m-b-sm">{name}</h2>
      <h3 className="text-xxl m-b">{numberWithDelimiter(summary.apps_total_all)} Apps</h3>
      <div className="table-responsive">
        <table className="table text-xxs">
          <tbody>
            <tr>
              <ProgressCells label="Apps" value={summary.apps_percentage} />
              <ProgressCells label="Games" value={summary.games_percentage} barClass="bg-red" />
            </tr>
            <tr>
              <ProgressCells
                label="Free"
                value={summary.apps_free_percentage}
                barClass="bg-dark-gray"
              />
              <ProgressCells
                label="Free"
                value={summary.games_free_percentage}
                barClass="bg-dark-gray"
              />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

StoreSummary.propTypes = {
  store: T.string.isRequired,
  summary: T.shape({
    apps_total_all: T.number,
    apps_percentage: T.number,
    games_percentage: T.number,
    apps_free_percentage: T.number,
    games_free_percentage: T.number,
  }).isRequired,
};

export default StoreSummary;
